import React from 'react';
import { Field } from 'react-final-form';
import { useFieldValue } from 'Shared/utils/hooks';

import Box from './Box/Box';
import './SidePanel.scss';

function getInitialCurrentWorkspace(workspaces) {
  const firstItem = workspaces[0];
  if (firstItem && firstItem.fullName) return firstItem;
  return {};
}

export default function SidePanel() {
  const workspaces = useFieldValue('workspaces');

  const initialCurrentWorkspace = getInitialCurrentWorkspace(workspaces);
  const groupWorkspacePresent = workspaces.some(w => w.isGroup);
  return (
    <div className="onboarding-workspaces-preview-side">
      <p className="text-center">{groupWorkspacePresent ? 'Workspaces' : '1:1 Workspaces'}</p>
      <Field hidden initialValue={initialCurrentWorkspace.uuid} name="currentWorkspace" type="text" component="input" />
      <div className="onboarding-workspaces-preview-side-items scrollbar">
        {workspaces.length ? (
          workspaces.map(workspace => <Box key={workspace.uuid} workspace={workspace} />)
        ) : (
          <>
            <Box />
            <Box />
          </>
        )}
      </div>
    </div>
  );
}
